import React from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {Grid, Input, Checkbox} from 'semantic-ui-react';
import {setErrorMessage, clearErrorMessage} from '../../../../../common/components/form/common';
import {dateFormatPicker, noTimeZoneShortISODate} from '../../../../../common/constants/datesFormat';
import {Label, ColumnValue} from './common/index';

const FeaturesInfoRow = ({
  generalInfo,
  isDisplayMode,
  onCheckboxChange,
  onChangeDates,
  onChangeInputField,
  productionDateFormatted,
}) => {
  return (
    <Grid.Row>
      <Grid.Column width={1}>
        <Checkbox
          name='mileageMeasurement'
          value={'KILOMETERS'}
          checked={generalInfo.mileageMeasurement === 'KILOMETERS'}
          onChange={onCheckboxChange}
          disabled={isDisplayMode}
          radio
        />
        Km
      </Grid.Column>
      <Grid.Column width={1} className='millas-container'>
        <Checkbox
          name='mileageMeasurement'
          value={'MILLAS'}
          checked={generalInfo.mileageMeasurement === 'MILLAS'}
          onChange={onCheckboxChange}
          disabled={isDisplayMode}
          radio
        />
        Millas
      </Grid.Column>
      <Grid.Column width={2}>
        <Input
          type='number'
          value={generalInfo.mileage || ''}
          onChange={(e, {value}) => onChangeInputField('mileage', value)}
          onInvalid={(event) =>
            setErrorMessage('Por favor, llene este campo', event)
          }
          onInput={clearErrorMessage}
          disabled={isDisplayMode}
          required={true}
          placeholder='Kilometraje'
          autoComplete='off'
        />
      </Grid.Column>
      <Label width={2} label='Fecha de Venta' />
      <Grid.Column width={3}>
        <DatePicker
          customInput={<Input icon='calendar' size='small' />}
          dateFormat={dateFormatPicker}
          selected={
            generalInfo.saleOfDate ?
              moment(generalInfo.saleOfDate, noTimeZoneShortISODate).toDate() :
              null
          }
          onChange={(date) => onChangeDates('saleOfDate', date)}
          locale='es'
          disabled={isDisplayMode}
          placeholderText='Fecha de Venta'
        />
      </Grid.Column>
      <Label width={2} label='Fecha de Producción' />
      <ColumnValue width={2} value={productionDateFormatted} />
    </Grid.Row>
  );
};

export default FeaturesInfoRow;
